import React, { useEffect, useState } from 'react';
import JSZip from 'jszip';
import * as d3 from 'd3';
import './App.css';
import Swiping from './Swiping'
import Start from './pages/Start'
import Smittede from './pages/Smittede';
import Nyindlagte from './pages/Nyindlagte';
import Døde from './pages/Døde';
import Epilog from './pages/Epilog';
import Indlagte from './pages/Indlagte';
import Install from './components/Install';
//import SmittedePlot from './pages/SmittedePlot';

const parseDate = d3.timeParse("%Y-%m-%d %H")

function App() {
	const [data, setData] = useState({ live: undefined, timeseries: undefined, isLoaded: false })
	useEffect(() => {

		const newestZip = async (number) => {
			const response = await fetch('https://covid19.ssi.dk/overvagningsdata/download-fil-med-overvaagningdata')
			const website = await response.text()
			const parsed = new DOMParser().parseFromString(website, "text/html")
			try {
				return document.adoptNode(parsed.querySelector(`.accordion:nth-child(${number}) a`)).href;
			} catch (error) {
				return undefined
			}
		}

		const getZip = async (url) => {
			return fetch(url)
				.then(response => ({
					live: true,
					zip: response.arrayBuffer()
				}))
				.catch(error => ({
					live: false,
					zip: undefined // TODO: Fall back on latest zip user has seen. Use localStorage.
				}))

		}

		const getData1 = async ({ live, zip }) => {
			const archive = await JSZip.loadAsync(zip)
			const timeseries = {
				kpis: d3.dsvFormat(";").parse(await archive.file("Kommunalt_DB/01_noegletal.csv").async("text")).map((d) => ({
					date: parseDate(`${d.Dato} 12`),
					newCases: +d['Bekr�ftede tilf�lde i alt siden sidste opdatering'],
					newDeaths: +d["D�dsfald siden sidste opdatering"],
					newHospitalized: +d["Nyindl�ggelser siden sidste opdatering"],
					currentHospitalized: +d["Indl�ggelser i dag"],
					currentIntensive: +d["Indl�ggelser i dag (intensiv)"],
					currentRespirator: +d["Indl�ggelser i dag (respirator)"]
				}))
			}
			return ({ live, timeseries, isLoaded: true })
		}

		newestZip(1).then(getZip).then(getData1).then(setData)
	}, [])

	if (data.isLoaded) {
		return (
			<div>
				<Swiping>
					<Start ready={data.isLoaded} live={data.live} />
					<Smittede smittede={data.timeseries.kpis} />
					<Nyindlagte nyindlagte={data.timeseries.kpis} />
					<Indlagte data={data.timeseries.kpis} />
					<Døde døde={data.timeseries.kpis} />
					<Epilog />
				</Swiping>
				<Install />
			</div>
		)
	}
	return <Start ready={data.isLoaded} live={data.live} />
}

export default App;

// TODO
// Lav flere swipe/fact cards, fx dem fra notebooken
// Gem data i localStorage
// Klik og tilt for at se detaljerede grafer/søjlediagram
// Bedre startside: Loader -> Fortæl om live eller lokal kopi. 1 sekund efter slide automatisk til første graf. Dermed lærer man at slide og man kan slide tilbage og se startsiden igen.
// Prevent up/down scroll, så den føles mere native

